import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AboutPage: React.FC = () => {
  useEffect(() => {
    document.title = 'About Us | Sports Platform';
  }, []);

  return (
    <main>
      <header className="py-5">
        <div className="container">
          <div className="mb-3">
            <Link to="/" className="btn btn-outline-secondary btn-sm">
              <i className="bi bi-arrow-left me-1"></i>
              Back to Home
            </Link>
          </div>
          <div className="text-center">
            <h1 className="display-6 fw-bold text-white">Empowering Tape Tennis Cricket Across Bangladesh</h1>
            <p className="text-muted mt-3">
              From grassroots talent to national tournaments — we connect players, teams, and
              opportunities.
            </p>
          </div>
        </div>
      </header>

      <section className="py-5">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <h2 className="h4 mb-3">Who We Are</h2>
              <p className="text-muted mb-0">
                We are a sports-first organization dedicated to Tape Tennis Cricket. Our focus is on
                fair play, transparency, and long-term growth for players and teams. We work closely
                with communities to ensure every tournament, registration, and opportunity is
                accessible and honest.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="card card-surface h-100">
                <div className="card-body">
                  <h3 className="h6 text-uppercase text-muted mb-3">Our Commitment</h3>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">Community-driven decisions</li>
                    <li className="mb-2">Clear rules and transparent processes</li>
                    <li className="mb-2">Player development at every level</li>
                    <li>Respect for the spirit of the game</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <h2 className="h4 mb-4 text-center">What We Do</h2>
          <div className="row g-4">
            {[
              {
                title: 'Tournament Management',
                text: 'Organize district & national-level events with clear scheduling and fair play.',
                icon: 'bi-trophy',
              },
              {
                title: 'Player Registration',
                text: 'Digital registration, ID cards, and accurate records for every player.',
                icon: 'bi-clipboard-check',
              },
              {
                title: 'Apparel & Jerseys',
                text: 'Custom jerseys, teamwear, and production support for clubs and academies.',
                icon: 'bi-shirt',
              },
              {
                title: 'Talent Scouting & Hunting',
                text: 'Identify and promote emerging players through verified competitions.',
                icon: 'bi-search',
              },
            ].map((item) => (
              <div className="col-md-6 col-lg-3" key={item.title}>
                <div className="card card-surface h-100">
                  <div className="card-body">
                    <i className={`bi ${item.icon} fs-3 text-success`} />
                    <h3 className="h6 mt-3">{item.title}</h3>
                    <p className="text-muted mb-0">{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <h2 className="h4 mb-4 text-center">Our Mission &amp; Vision</h2>
          <div className="row g-4">
            <div className="col-lg-6">
              <div
                className="card card-surface h-100"
              >
                <div className="card-body">
                  <h3 className="h6 text-uppercase text-muted">Mission</h3>
                  <p className="mb-0">
                    To create a structured, transparent, and inclusive ecosystem for Tape Tennis
                    Cricket players.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="card card-surface h-100"
              >
                <div className="card-body">
                  <h3 className="h6 text-uppercase text-muted">Vision</h3>
                  <p className="mb-0">
                    To become the leading digital platform supporting grassroots sports across
                    multiple disciplines.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <h2 className="h4 mb-4 text-center">Why Trust Us</h2>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <ul className="list-group list-group-flush">
                <li className="list-group-item">Transparent registration &amp; payments</li>
                <li className="list-group-item">Verified tournaments with clear rules</li>
                <li className="list-group-item">Secure digital ID cards</li>
                <li className="list-group-item">District-wise representation</li>
                <li className="list-group-item">Player-first approach</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <h2 className="h4 mb-4 text-center">Our Journey</h2>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <ol className="list-group list-group-numbered">
                <li className="list-group-item">Started with local community events.</li>
                <li className="list-group-item">Expanded to district-level tournaments.</li>
                <li className="list-group-item">Building national championships.</li>
                <li className="list-group-item">Preparing for multi-sport expansion.</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container text-center">
          <h2 className="h4 mb-3">Be part of the journey.</h2>
          <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center">
            <Link to="/events" className="btn btn-arena">
              View Events
            </Link>
            <Link to="/auth" className="btn btn-outline-success">
              Register / Login
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutPage;
